import { gql } from '@apollo/client'

const INVITE_USER_TO_STORE = gql`
  mutation InviteUserToStore($phone: String!, $email: String!, $name: String!) {
    inviteUserToStore(phone: $phone, email: $email, name: $name) {
      id
    }
  }
`

export default INVITE_USER_TO_STORE
